import { TEventTicketDate } from 'Domain/Models';

type TDates = {
  type: string;
  dates: TEventTicketDate[];

  startDate: Date|null;
  startStartTime: string;
  startEndTime: string|null;

  endDate: Date|null;
  endStartTime: string;
  endEndTime: string|null;
}

export const getDatesByStartEnd = ({ type = 'onetime', dates = [], startDate, startStartTime, startEndTime, endDate, endStartTime, endEndTime }: TDates) => {

  if(type === 'onetime') {
    return [{date: startDate, start: startStartTime, end: startEndTime}];
  }
  if(type === 'start_end') {
    return [
      {date: startDate, start: startStartTime, end: startEndTime},
      {date: endDate, start: endStartTime, end: endEndTime}
    ];
  }
  return [ ...dates.map(date => ({ ...date })) ];

}
